import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { DBServerRecord } from '../models/DBServerRecord';

/**
 * no description
 */
export class GetDatabasesByServerApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get all databases for a given server and snapshot
   * @param serverId ID of the database server
   * @param snapshotId ID of the snapshot
   * @param projectId The project ID
   * @param dbName 
   */
  public async getDatabasesByServer(serverId: string, snapshotId: string, projectId: string, dbName?: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'serverId' is not null or undefined
    if (serverId === null || serverId === undefined) {
      throw new RequiredError("GetDatabasesByServerApi", "getDatabasesByServer", "serverId");
    }


    // verify required parameter 'snapshotId' is not null or undefined
    if (snapshotId === null || snapshotId === undefined) {
      throw new RequiredError("GetDatabasesByServerApi", "getDatabasesByServer", "snapshotId");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("GetDatabasesByServerApi", "getDatabasesByServer", "projectId");
    }



    // Path Params
    const localVarPath = '/projects/{projectId}/db/{serverId}/snapshots/{snapshotId}/object-tree'
      .replace('{' + 'serverId' + '}', encodeURIComponent(String(serverId)))
      .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (dbName !== undefined) {
      requestContext.setQueryParam("dbName", ObjectSerializer.serialize(dbName, "string", "tobedefined"));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class GetDatabasesByServerApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to getDatabasesByServer
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async getDatabasesByServerWithHttpInfo(response: ResponseContext): Promise<HttpInfo<DBServerRecord >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: DBServerRecord = ObjectSerializer.deserialize(
        await response.body.json(),
        "DBServerRecord", ""
      ) as DBServerRecord;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "No records found", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: DBServerRecord = await response.body.json() as DBServerRecord;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
